<template>
    <div class="left">
      <el-menu default-active="1-4-1" class="el-menu-vertical-demo"  :collapse=false :unique-opened=true :router=true>
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Base Setting</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/development" >Development</el-menu-item>
            <el-menu-item index="/tower" >Tower</el-menu-item>
            <el-menu-item index="/floor">Floor</el-menu-item>
            <el-menu-item index="/flat">Flat</el-menu-item>
            <el-menu-item index="/dRelation">Relation</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Items Setting</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/location">Location</el-menu-item>
            <el-menu-item index="/trade">Trade</el-menu-item>
            <el-menu-item index="/item">Item</el-menu-item>
            <el-menu-item index="/type">Defect Type</el-menu-item>
            <el-menu-item index="/lRelation">Relation</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Records</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/record">Record</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
</template>

<script>
    export default {
        name: "Left",
      methods:{

      }
    }
</script>

<style scoped>

  .left {
    width: 200px;
    position: relative;
    height: 100%;
    background-color: #f0f6f6;
    border-right:  1px solid #cedfea;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Left.vue